module.exports = __webpack_public_path__ + "img/meme_27.24699550.jpg";